import { ELanguages } from '../../i18n';
import type { PreferredLanguage } from '../../api/users';

const languageCode: { [key in PreferredLanguage]: key } = {
  sv: 'sv',
  en: 'en',
  es: 'es',
  fi: 'fi',
  nl: 'nl',
  pt: 'pt',
};

export const LANGUAGE_CODE_MAPPER: Record<string, PreferredLanguage> = {
  se: 'sv',
  'en-TT': 'en',
  ...Object.fromEntries(Object.values(languageCode).map(code => [code, code])),
};

export const mapFromPreferredLanguageToELanguages = (
  language: PreferredLanguage
): ELanguages | null => {
  switch (language) {
    case 'sv':
      return ELanguages.se;
    case 'en':
      return ELanguages.en;
    case 'nl':
      return ELanguages.nl;
    case 'fi':
      return ELanguages.fi;
    case 'pt':
      return ELanguages.pt;
    case 'es':
      return ELanguages.es;
    default:
      return ELanguages.en;
  }
};
